export default __webpack_public_path__ + "static/media/Graviola-Soft-Regular.2178e801.otf";